export const europeanCountry = [
  {
    value: "AD",
    label: "Andorra",
    name: "European",
  },
  {
    value: "AE",
    label: "United Arab Emirates",
    name: "Other",
  },
  {
    value: "AF",
    label: "Afghanistan",
    name: "Other",
  },
  {
    value: "AG",
    label: "Antigua and Barbuda",
    name: "Other",
  },
  {
    value: "AI",
    label: "Anguilla",
    name: "Other",
  },
  {
    value: "AL",
    label: "Albania",
    name: "European",
  },
  {
    value: "AM",
    label: "Armenia",
    name: "Other",
  },
  {
    value: "AN",
    label: "Netherlands Antilles",
    name: "European",
  },
  {
    value: "AO",
    label: "Angola",
    name: "Other",
  },
  {
    value: "AQ",
    label: "Antarctica",
    name: "Other",
  },
  {
    value: "AR",
    label: "Argentina",
    name: "Other",
  },
  {
    value: "AS",
    label: "American Samoa",
    name: "Other",
  },
  {
    value: "AT",
    label: "Austria",
    name: "European",
  },
  {
    value: "AU",
    label: "Australia",
    name: "Other",
  },
  {
    value: "AW",
    label: "Aruba",
    name: "Other",
  },
  {
    value: "AZ",
    label: "Azerbaijan",
    name: "Other",
  },
  {
    value: "BA",
    label: "Bosnia and Herzegovina",
    name: "European",
  },
  {
    value: "BB",
    label: "Barbados",
    name: "Other",
  },
  {
    value: "BD",
    label: "Bangladesh",
    name: "Other",
  },
  {
    value: "BE",
    label: "Belgium",
    name: "European",
  },
  {
    value: "BF",
    label: "Burkina Faso",
    name: "Other",
  },
  {
    value: "BG",
    label: "Bulgaria",
    name: "European",
  },
  {
    value: "BH",
    label: "Bahrain",
    name: "Other",
  },
  {
    value: "BI",
    label: "Burundi",
    name: "Other",
  },
  {
    value: "BJ",
    label: "Benin",
    name: "Other",
  },
  {
    value: "BL",
    label: "Saint Barthelemy",
    name: "Other",
  },
  {
    value: "BM",
    label: "Bermuda",
    name: "Other",
  },
  {
    value: "BN",
    label: "Brunei",
    name: "Other",
  },
  {
    value: "BO",
    label: "Bolivia",
    name: "Other",
  },
  {
    value: "BR",
    label: "Brazil",
    name: "Other",
  },
  {
    value: "BS",
    label: "Bahamas",
    name: "Other",
  },
  {
    value: "BT",
    label: "Bhutan",
    name: "Other",
  },
  {
    value: "BW",
    label: "Botswana",
    name: "Other",
  },
  {
    value: "BY",
    label: "Belarus",
    name: "European",
  },
  {
    value: "BZ",
    label: "Belize",
    name: "Other",
  },
  {
    value: "CA",
    label: "Canada",
    name: "Other",
  },
  {
    value: "CC",
    label: "Cocos Islands",
    name: "Other",
  },
  {
    value: "CD",
    label: "Democratic Republic of the Congo",
    name: "Other",
  },
  {
    value: "CF",
    label: "Central African Republic",
    name: "Other",
  },
  {
    value: "CG",
    label: "Republic of the Congo",
    name: "Other",
  },
  {
    value: "CH",
    label: "Switzerland",
    name: "European",
  },
  {
    value: "CI",
    label: "Ivory Coast",
    name: "Other",
  },
  {
    value: "CK",
    label: "Cook Islands",
    name: "Other",
  },
  {
    value: "CL",
    label: "Chile",
    name: "Other",
  },
  {
    value: "CM",
    label: "Cameroon",
    name: "Other",
  },
  {
    value: "CN",
    label: "China",
    name: "Other",
  },
  {
    value: "CO",
    label: "Colombia",
    name: "Other",
  },
  {
    value: "CR",
    label: "Costa Rica",
    name: "Other",
  },
  {
    value: "CU",
    label: "Cuba",
    name: "Other",
  },
  {
    value: "CV",
    label: "Cape Verde",
    name: "Other",
  },
  {
    value: "CW",
    label: "Curacao",
    name: "Other",
  },
  {
    value: "CX",
    label: "Christmas Island",
    name: "Other",
  },
  {
    value: "CY",
    label: "Cyprus",
    name: "Other",
  },
  {
    value: "CZ",
    label: "Czech Republic",
    name: "European",
  },
  {
    value: "DE",
    label: "Germany",
    name: "European",
  },
  {
    value: "DJ",
    label: "Djibouti",
    name: "Other",
  },
  {
    value: "DK",
    label: "Denmark",
    name: "European",
  },
  {
    value: "DM",
    label: "Dominica",
    name: "Other",
  },
  {
    value: "DO",
    label: "Dominican Republic",
    name: "Other",
  },
  {
    value: "DZ",
    label: "Algeria",
    name: "Other",
  },
  {
    value: "EC",
    label: "Ecuador",
    name: "Other",
  },
  {
    value: "EE",
    label: "Estonia",
    name: "European",
  },
  {
    value: "EG",
    label: "Egypt",
    name: "Other",
  },
  {
    value: "EH",
    label: "Western Sahara",
    name: "Other",
  },
  {
    value: "ER",
    label: "Eritrea",
    name: "Other",
  },
  {
    value: "ES",
    label: "Spain",
    name: "European",
  },
  {
    value: "ET",
    label: "Ethiopia",
    name: "Other",
  },
  {
    value: "FI",
    label: "Finland",
    name: "European",
  },
  {
    value: "FJ",
    label: "Fiji",
    name: "Other",
  },
  {
    value: "FK",
    label: "Falkland Islands",
    name: "Other",
  },
  {
    value: "FM",
    label: "Micronesia",
    name: "Other",
  },
  {
    value: "FO",
    label: "Faroe Islands",
    name: "European",
  },
  {
    value: "FR",
    label: "France",
    name: "European",
  },
  {
    value: "GA",
    label: "Gabon",
    name: "Other",
  },
  {
    value: "GB",
    label: "United Kingdom",
    name: "European",
  },
  {
    value: "GD",
    label: "Grenada",
    name: "Other",
  },
  {
    value: "GE",
    label: "Georgia",
    name: "Other",
  },
  {
    value: "GG",
    label: "Guernsey",
    name: "Other",
  },
  {
    value: "GH",
    label: "Ghana",
    name: "Other",
  },
  {
    value: "GI",
    label: "Gibraltar",
    name: "European",
  },
  {
    value: "GL",
    label: "Greenland",
    name: "Other",
  },
  {
    value: "GM",
    label: "Gambia",
    name: "Other",
  },
  {
    value: "GN",
    label: "Guinea",
    name: "Other",
  },
  {
    value: "GQ",
    label: "Equatorial Guinea",
    name: "Other",
  },
  {
    value: "GR",
    label: "Greece",
    name: "European",
  },
  {
    value: "GT",
    label: "Guatemala",
    name: "Other",
  },
  {
    value: "GU",
    label: "Guam",
    name: "Other",
  },
  {
    value: "GW",
    label: "Guinea-Bissau",
    name: "Other",
  },
  {
    value: "GY",
    label: "Guyana",
    name: "Other",
  },
  {
    value: "HK",
    label: "Hong Kong",
    name: "Other",
  },
  {
    value: "HN",
    label: "Honduras",
    name: "Other",
  },
  {
    value: "HR",
    label: "Croatia",
    name: "European",
  },
  {
    value: "HT",
    label: "Haiti",
    name: "Other",
  },
  {
    value: "HU",
    label: "Hungary",
    name: "European",
  },
  {
    value: "ID",
    label: "Indonesia",
    name: "Other",
  },
  {
    value: "IE",
    label: "Ireland",
    name: "European",
  },
  {
    value: "IL",
    label: "Israel",
    name: "Other",
  },
  {
    value: "IM",
    label: "Isle of Man",
    name: "European",
  },
  {
    value: "IN",
    label: "India",
    name: "Other",
  },
  {
    value: "IO",
    label: "British Indian Ocean Territory",
    name: "Other",
  },
  {
    value: "IQ",
    label: "Iraq",
    name: "Other",
  },
  {
    value: "IR",
    label: "Iran",
    name: "Other",
  },
  {
    value: "IS",
    label: "Iceland",
    name: "Other",
  },
  {
    value: "IT",
    label: "Italy",
    name: "European",
  },
  {
    value: "JE",
    label: "Jersey",
    name: "Other",
  },
  {
    value: "JM",
    label: "Jamaica",
    name: "Other",
  },
  {
    value: "JO",
    label: "Jordan",
    name: "Other",
  },
  {
    value: "JP",
    label: "Japan",
    name: "Other",
  },
  {
    value: "KE",
    label: "Kenya",
    name: "Other",
  },
  {
    value: "KG",
    label: "Kyrgyzstan",
    name: "Other",
  },
  {
    value: "KH",
    label: "Cambodia",
    name: "Other",
  },
  {
    value: "KI",
    label: "Kiribati",
    name: "Other",
  },
  {
    value: "KM",
    label: "Comoros",
    name: "Other",
  },
  {
    value: "KN",
    label: "Saint Kitts and Nevis",
    name: "Other",
  },
  {
    value: "KP",
    label: "North Korea",
    name: "Other",
  },
  {
    value: "KR",
    label: "South Korea",
    name: "Other",
  },
  {
    value: "KW",
    label: "Kuwait",
    name: "Other",
  },
  {
    value: "KY",
    label: "Cayman Islands",
    name: "Other",
  },
  {
    value: "KZ",
    label: "Kazakhstan",
    name: "Other",
  },
  {
    value: "LA",
    label: "Laos",
    name: "Other",
  },
  {
    value: "LB",
    label: "Lebanon",
    name: "Other",
  },
  {
    value: "LC",
    label: "Saint Lucia",
    name: "Other",
  },
  {
    value: "LI",
    label: "Liechtenstein",
    name: "European",
  },
  {
    value: "LK",
    label: "Sri Lanka",
    name: "Other",
  },
  {
    value: "LR",
    label: "Liberia",
    name: "Other",
  },
  {
    value: "LS",
    label: "Lesotho",
    name: "Other",
  },
  {
    value: "LT",
    label: "Lithuania",
    name: "European",
  },
  {
    value: "LU",
    label: "Luxembourg",
    name: "European",
  },
  {
    value: "LV",
    label: "Latvia",
    name: "European",
  },
  {
    value: "LY",
    label: "Libya",
    name: "Other",
  },
  {
    value: "MA",
    label: "Morocco",
    name: "Other",
  },
  {
    value: "MC",
    label: "Monaco",
    name: "Other",
  },
  {
    value: "MD",
    label: "Moldova",
    name: "European",
  },
  {
    value: "ME",
    label: "Montenegro",
    name: "European",
  },
  {
    value: "MF",
    label: "Saint Martin",
    name: "Other",
  },
  {
    value: "MG",
    label: "Madagascar",
    name: "Other",
  },
  {
    value: "MH",
    label: "Marshall Islands",
    name: "Other",
  },
  {
    value: "MK",
    label: "Macedonia",
    name: "European",
  },
  {
    value: "ML",
    label: "Mali",
    name: "Other",
  },
  {
    value: "MM",
    label: "Myanmar",
    name: "Other",
  },
  {
    value: "MN",
    label: "Mongolia",
    name: "Other",
  },
  {
    value: "MO",
    label: "Macao",
    name: "Other",
  },
  {
    value: "MP",
    label: "Northern Mariana Islands",
    name: "Other",
  },
  {
    value: "MR",
    label: "Mauritania",
    name: "Other",
  },
  {
    value: "MS",
    label: "Montserrat",
    name: "Other",
  },
  {
    value: "MT",
    label: "Malta",
    name: "European",
  },
  {
    value: "MU",
    label: "Mauritius",
    name: "Other",
  },
  {
    value: "MV",
    label: "Maldives",
    name: "Other",
  },
  {
    value: "MW",
    label: "Malawi",
    name: "Other",
  },
  {
    value: "MX",
    label: "Mexico",
    name: "Other",
  },
  {
    value: "MY",
    label: "Malaysia",
    name: "Other",
  },
  {
    value: "MZ",
    label: "Mozambique",
    name: "Other",
  },
  {
    value: "NA",
    label: "Namibia",
    name: "Other",
  },
  {
    value: "NC",
    label: "New Caledonia",
    name: "Other",
  },
  {
    value: "NE",
    label: "Niger",
    name: "Other",
  },
  {
    value: "NG",
    label: "Nigeria",
    name: "Other",
  },
  {
    value: "NI",
    label: "Nicaragua",
    name: "Other",
  },
  {
    value: "NL",
    label: "Netherlands",
    name: "European",
  },
  {
    value: "NO",
    label: "Norway",
    name: "European",
  },
  {
    value: "NP",
    label: "Nepal",
    name: "Other",
  },
  {
    value: "NR",
    label: "Nauru",
    name: "Other",
  },
  {
    value: "NU",
    label: "Niue",
    name: "Other",
  },
  {
    value: "NZ",
    label: "New Zealand",
    name: "Other",
  },
  {
    value: "OM",
    label: "Oman",
    name: "Other",
  },
  {
    value: "PA",
    label: "Panama",
    name: "Other",
  },
  {
    value: "PE",
    label: "Peru",
    name: "Other",
  },
  {
    value: "PF",
    label: "French Polynesia",
    name: "Other",
  },
  {
    value: "PG",
    label: "Papua New Guinea",
    name: "Other",
  },
  {
    value: "PH",
    label: "Philippines",
    name: "Other",
  },
  {
    value: "PK",
    label: "Pakistan",
    name: "Other",
  },
  {
    value: "PL",
    label: "Poland",
    name: "European",
  },
  {
    value: "PM",
    label: "Saint Pierre and Miquelon",
    name: "Other",
  },
  {
    value: "PN",
    label: "Pitcairn",
    name: "Other",
  },
  {
    value: "PR",
    label: "Puerto Rico",
    name: "Other",
  },
  {
    value: "PS",
    label: "Palestine",
    name: "Other",
  },
  {
    value: "PT",
    label: "Portugal",
    name: "European",
  },
  {
    value: "PW",
    label: "Palau",
    name: "Other",
  },
  {
    value: "PY",
    label: "Paraguay",
    name: "Other",
  },
  {
    value: "QA",
    label: "Qatar",
    name: "Other",
  },
  {
    value: "RE",
    label: "Reunion",
    name: "Other",
  },
  {
    value: "RO",
    label: "Romania",
    name: "European",
  },
  {
    value: "RS",
    label: "Serbia",
    name: "European",
  },
  {
    value: "RU",
    label: "Russia",
    name: "European",
  },
  {
    value: "RW",
    label: "Rwanda",
    name: "Other",
  },
  {
    value: "SA",
    label: "Saudi Arabia",
    name: "Other",
  },
  {
    value: "SB",
    label: "Solomon Islands",
    name: "Other",
  },
  {
    value: "SC",
    label: "Seychelles",
    name: "Other",
  },
  {
    value: "SD",
    label: "Sudan",
    name: "Other",
  },
  {
    value: "SE",
    label: "Sweden",
    name: "European",
  },
  {
    value: "SG",
    label: "Singapore",
    name: "Other",
  },
  {
    value: "SH",
    label: "Saint Helena",
    name: "Other",
  },
  {
    value: "SI",
    label: "Slovenia",
    name: "European",
  },
  {
    value: "SJ",
    label: "Svalbard and Jan Mayen",
    name: "Other",
  },
  {
    value: "SK",
    label: "Slovakia",
    name: "European",
  },
  {
    value: "SL",
    label: "Sierra Leone",
    name: "Other",
  },
  {
    value: "SM",
    label: "San Marino",
    name: "European",
  },
  {
    value: "SN",
    label: "Senegal",
    name: "Other",
  },
  {
    value: "SO",
    label: "Somalia",
    name: "Other",
  },
  {
    value: "SR",
    label: "Surilabel",
    name: "Other",
  },
  {
    value: "SS",
    label: "South Sudan",
    name: "Other",
  },
  {
    value: "ST",
    label: "Sao Tome and Principe",
    name: "Other",
  },
  {
    value: "SV",
    label: "El Salvador",
    name: "Other",
  },
  {
    value: "SX",
    label: "Sint Maarten",
    name: "Other",
  },
  {
    value: "SY",
    label: "Syria",
    name: "Other",
  },
  {
    value: "SZ",
    label: "Swaziland",
    name: "Other",
  },
  {
    value: "TC",
    label: "Turks and Caicos Islands",
    name: "Other",
  },
  {
    value: "TD",
    label: "Chad",
    name: "Other",
  },
  {
    value: "TG",
    label: "Togo",
    name: "Other",
  },
  {
    value: "TH",
    label: "Thailand",
    name: "Other",
  },
  {
    value: "TJ",
    label: "Tajikistan",
    name: "Other",
  },
  {
    value: "TK",
    label: "Tokelau",
    name: "Other",
  },
  {
    value: "TL",
    label: "East Timor",
    name: "Other",
  },
  {
    value: "TM",
    label: "Turkmenistan",
    name: "Other",
  },
  {
    value: "TN",
    label: "Tunisia",
    name: "Other",
  },
  {
    value: "TO",
    label: "Tonga",
    name: "Other",
  },
  {
    value: "TR",
    label: "Turkey",
    name: "Other",
  },
  {
    value: "TT",
    label: "Trinidad and Tobago",
    name: "Other",
  },
  {
    value: "TV",
    label: "Tuvalu",
    name: "Other",
  },
  {
    value: "TW",
    label: "Taiwan",
    name: "Other",
  },
  {
    value: "TZ",
    label: "Tanzania",
    name: "Other",
  },
  {
    value: "UA",
    label: "Ukraine",
    name: "European",
  },
  {
    value: "UG",
    label: "Uganda",
    name: "Other",
  },
  {
    value: "US",
    label: "United States",
    name: "Other",
  },
  {
    value: "UY",
    label: "Uruguay",
    name: "Other",
  },
  {
    value: "UZ",
    label: "Uzbekistan",
    name: "Other",
  },
  {
    value: "VA",
    label: "Vatican",
    name: "Other",
  },
  {
    value: "VC",
    label: "Saint Vincent and the Grenadines",
    name: "Other",
  },
  {
    value: "VE",
    label: "Venezuela",
    name: "Other",
  },
  {
    value: "VG",
    label: "British Virgin Islands",
    name: "Other",
  },
  {
    value: "VI",
    label: "U.S. Virgin Islands",
    name: "Other",
  },
  {
    value: "VN",
    label: "Vietnam",
    name: "Other",
  },
  {
    value: "VU",
    label: "Vanuatu",
    name: "Other",
  },
  {
    value: "WF",
    label: "Wallis and Futuna",
    name: "Other",
  },
  {
    value: "WS",
    label: "Samoa",
    name: "Other",
  },
  {
    value: "XK",
    label: "Kosovo",
    name: "Other",
  },
  {
    value: "YE",
    label: "Yemen",
    name: "Other",
  },
  {
    value: "YT",
    label: "Mayotte",
    name: "Other",
  },
  {
    value: "ZA",
    label: "South Africa",
    name: "Other",
  },
  {
    value: "ZM",
    label: "Zambia",
    name: "Other",
  },
  {
    value: "ZW",
    label: "Zimbabwe",
    name: "Other",
  },
];
